import logoImg from "../assets/logo.png"; // This goes up one level and into assets

export default function Logo({ showText = true }) {
  return (
    <div className="flex items-center gap-3">
      {/* THE LOGO BOX (Neobrutalist Style) */}
      <div className="w-10 h-10 bg-white border-2 border-foreground rounded-lg shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] flex items-center justify-center overflow-hidden shrink-0 p-1">
        <img 
          src={logoImg} 
          alt="DmFlio Logo" 
          className="w-full h-full object-contain" 
        />
      </div>

      {/* THE BRAND NAME */}
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-black text-2xl tracking-tighter uppercase italic text-foreground">
            DmFlio
          </span>
          <span className="text-[10px] font-black uppercase tracking-[0.2em] text-primary">
            Automation
          </span>
        </div>
      )}
    </div>
  );
}